<template>
  <div class="nsale_upload">
    <cube-upload
      ref="upload"
      v-model="files"
      :action="action"
      @files-added="addedHandler"
      @file-error="errHandler"
    >
      <div class="clear-fix">
        <cube-upload-file
          v-for="(file, i) in files"
          :file="file"
          :key="i"
        ></cube-upload-file>
        <cube-upload-btn :multiple="false">
          <div>
            <img class="i_icon_" :src="imgSrc1" alt="img" />
          </div>
        </cube-upload-btn>
      </div>
    </cube-upload>

    <cube-upload
      ref="upload1"
      v-model="files1"
      :action="action"
      @files-added="addedHandler1"
      @file-error="errHandler"
    >
      <div class="clear-fix">
        <cube-upload-file
          v-for="(file, i) in files1"
          :file="file"
          :key="i"
        ></cube-upload-file>
        <cube-upload-btn :multiple="false">
          <div>
            <img class="i_icon_" :src="imgSrc2" alt="img" />
          </div>
        </cube-upload-btn>
      </div>
    </cube-upload>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "1"
    }
  },
  computed: {
    imgSrc1() {
      return require(`../../../../assets/image/nsale/pcenter/icon${this.type}_1.png`);
    },
    imgSrc2() {
      return require(`../../../../assets/image/nsale/pcenter/icon${this.type}_2.png`);
    }
  },
  data() {
    return {
      action: "//jsonplaceholder.typicode.com/photos/",
      files: [],
      files1: [],
    };
  },
  mounted() {
    console.log(this.type, "----");
    
  },
  methods: {
    addedHandler1() {
      const file = this.files[0];
      file && this.$refs.upload1.removeFile(file);
    },
    addedHandler() {
      const file = this.files[0];
      file && this.$refs.upload.removeFile(file);
    },
    errHandler(file) {
      // const msg = file.response.message
      this.$createToast({
        type: "warn",
        txt: "Upload fail",
        time: 1000
      }).show();
    }
  }
};
</script>

<style lang="scss" scoped>
.nsale_upload {
  .i_icon_ {
    height: 188px;
    width: 100%;
    margin: 20px 0;
  }
}
</style>
